export default __webpack_public_path__ + "6a19443605991d57cb8fe13b28dd1843.png";